module.exports = __webpack_public_path__ + "assets/img/zh-Hant-f56ee1e3.png";